export default "<div\n\tclass=\"share inline-flex justify-center\">\n\t\n\n\t\t\n\t\t\t\n\t\t\n\t\t</div>\n"